import { Phone, ShieldCheck, Clock } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export const Hero = () => (
  <section
    id="top"
    data-testid="hero-section"
    className="relative overflow-hidden bg-white pt-40 sm:pt-44 lg:pt-48 pb-20 lg:pb-28"
  >
    <div
      aria-hidden="true"
      className="absolute inset-0 -z-0 bg-cover bg-center opacity-[0.08]"
      style={{
        backgroundImage:
          "url(https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxzaWduaW5nJTIwbGVnYWwlMjBkb2N1bWVudCUyMHBlbiUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzgzNTQxNjM0fDA&ixlib=rb-4.1.0&q=85)",
      }}
    />
    <div
      aria-hidden="true"
      className="absolute inset-0 -z-0 bg-gradient-to-b from-white via-white/95 to-white"
    />

    <div className="container-tn relative">
      <div className="max-w-4xl">
        <div className="reveal flex items-center gap-3">
          <span className="h-px w-10 bg-gold" />
          <span className="eyebrow">Andreas Aigner · Illinois Notary Public</span>
        </div>

        <h1
          className="reveal mt-6 font-serif font-bold uppercase text-navy text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-[0.03em]"
          style={{ animationDelay: "80ms" }}
          data-testid="hero-headline"
        >
          A Notary Who
          <br />
          <span className="text-gold">Comes To You.</span>
        </h1>

        <p
          className="reveal mt-6 text-lg sm:text-xl text-mutedink max-w-2xl leading-relaxed"
          style={{ animationDelay: "160ms" }}
        >
          Mobile notary public serving River Grove and the western &amp; northwest Chicago suburbs.
          Homes, offices, hospitals, and care facilities — days, evenings, and weekends.
        </p>

        <div
          className="reveal mt-5"
          style={{ animationDelay: "200ms" }}
        >
          <span
            data-testid="hero-bilingual-badge"
            className="inline-flex items-center whitespace-nowrap rounded-full bg-navy text-gold font-serif uppercase tracking-[0.22em] text-[10px] sm:text-xs font-semibold px-4 py-1.5 border border-gold/25"
          >
            English &amp; Deutsch spoken
          </span>
        </div>

        <div
          className="reveal mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4"
          style={{ animationDelay: "240ms" }}
        >
          <a
            href={BUSINESS.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-gold"
            data-testid="hero-book-button"
          >
            Book Online
          </a>
          <a
            href={`tel:${BUSINESS.phoneHref}`}
            className="btn-navy-outline"
            data-testid="hero-call-button"
          >
            <Phone className="w-4 h-4" /> Call or Text {BUSINESS.phoneDisplay}
          </a>
        </div>

        <p
          className="reveal mt-6 text-sm text-mutedink flex flex-wrap items-center gap-x-4 gap-y-2"
          style={{ animationDelay: "320ms" }}
        >
          <span className="inline-flex items-center gap-2">
            <ShieldCheck className="w-4 h-4 text-gold" />
            Commissioned Illinois Notary Public
          </span>
          <span className="hidden sm:inline text-gold-soft">·</span>
          <span className="inline-flex items-center gap-2">
            <Clock className="w-4 h-4 text-gold" />
            Same-day &amp; rush appointments available
          </span>
        </p>
      </div>
    </div>
  </section>
);
